const BorderedFrameBox = ({title, body, labelBgLight, labelBgDark, bgColor, icon, borderColor='border-slate-400 dark:border-slate-600', shadow}) => {
     return (<div className={`rounded-xl ${bgColor || 'bg-white dark:bg-slate-950'} relative items-center px-4 pt-6 pb-4 justify-center min-h-24 w-full border ${borderColor} ${shadow}`}>
                         {/* add flex to class above to have caption centered  */}
  <div className="absolute top-1/2 top-[-2px] transform -translate-y-1/2 text-gray-900 dark:text-gray-300">
    <span className={`${labelBgLight || 'bg-white'} ${labelBgDark || bgColor || 'dark:bg-gray-800'} rounded-md px-4 py-1 font-inter text-black dark:text-slate-300 text-xs border border-teal-400 font-inter`}>
    {icon} {title}</span>
    
  </div>
  {body}
</div>)
}

export default BorderedFrameBox